import React from "react"
import { TouchableOpacity } from "~/ui/primitives"
import styled from '~/ui/styled'
import { Event, EventNames } from "../../proto"

const Text = styled.Text`
  margin-right: 4px;
`

const ButtonText = styled.Text`
  margin-right: 4px;
  text-decoration: underline;
  color: blue;
`

const Code = styled.Text`
  padding: 6px 0;
  background-color: #e3e6ec;
`

const Row = styled.View`
  background-color: ${({ bg }) => bg || '#e3e6ec'};
  flex-direction: row;
  padding: 4px;
  justify-content: space-between;
`

const Section = styled.View`
  /* flex-direction: row; */
  background-color: ${(props) => props.bg || "#e3e6ec"};
  padding: 2px;
  margin-top: 2px;
  /* justify-content: space-between; */
  /* flex-wrap: wrap; */
`

const EventType = ({ publish }) => {
  return <Text>{publish ? ">>>" : "<<<"}</Text>
}

const Replay = (props) => (
  <TouchableOpacity {...props}>
    <ButtonText>{"[重放]️"}</ButtonText>
  </TouchableOpacity>
)

const EventName = ({ name, publish, onRelpay }) => (
  <Row bg={publish ? "#afbfa0" : "#a5bfd7"}>
    <Text>
      <EventType publish={publish} />
      {EventNames[name]}
    </Text>
    <Replay onClick={onRelpay} />
  </Row>
)

const EventData = ({ data }) => <Code>{JSON.stringify(data, null, 2)}</Code>
interface Props {
  event: Event
  onReplay: () => void
}

export const EventListItem: React.FC<Props> = ({ event, onReplay }) => (
  <Section bg={"white"}>
    <EventName {...event} onRelpay={onReplay} />
    <EventData data={event.data} />
  </Section>
)
